import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { BOOKING_URL } from '../config/booking';

const Pilates = () => {
  const benefits = [
    'Verbesserte Körperhaltung und Ausrichtung',
    'Gestärkte Core-Muskulatur',
    'Erhöhte Flexibilität und Beweglichkeit',
    'Reduzierte Rückenschmerzen',
    'Bessere Körperwahrnehmung',
    'Stressabbau und mentale Klarheit'
  ];

  const pilatesTypes = [
    {
      title: 'Reformer Pilates',
      description: 'Klassisches Pilates am Reformer für gezieltes Core-Training und Muskelaufbau.',
      image: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx5b2dhfGVufDB8fHx8MTc2Mjc1NTk4NXww&ixlib=rb-4.1.0&q=85',
      duration: '55 Min'
    },
    {
      title: 'Mat Pilates',
      description: 'Pilates auf der Matte mit Fokus auf Körpergewichtsübungen und Atemtechniken.',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx5b2dhfGVufDB8fHx8MTc2Mjc1NTk4NXww&ixlib=rb-4.1.0&q=85',
      duration: '50 Min'
    },
    {
      title: 'Private Sessions',
      description: '1:1 Pilates-Training mit individueller Betreuung und maßgeschneiderten Übungen.',
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx5b2dhfGVufDB8fHx8MTc2Mjc1NTk4NXww&ixlib=rb-4.1.0&q=85',
      duration: '60 Min'
    }
  ];

  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[70vh] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx5b2dhfGVufDB8fHx8MTc2Mjc1NTk4NXww&ixlib=rb-4.1.0&q=85"
            alt="Pilates"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 uppercase">
            Authentisches Pilates
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Studio-Pilates mit 1:1-Anleitung. Straffen Sie Ihren Core und aktivieren Sie die Geist-Körper-Verbindung.
          </p>
          <Button asChild size="lg" className="bg-white text-black hover:bg-white/90 h-12 px-8">
<a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">Probestunde buchen</a>
</Button>
        </div>
      </section>

      {/* About Pilates */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative aspect-[4/3]">
              <img 
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx5b2dhfGVufDB8fHx8MTc2Mjc1NTk4NXww&ixlib=rb-4.1.0&q=85"
                alt="Pilates"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Die Kraft von Pilates
              </h2>
              <p className="text-lg text-black/80 mb-8 leading-relaxed">
                Pilates ist mehr als nur ein Workout - es ist eine ganzheitliche Trainingsmethode, die Körper und Geist stärkt. Bei POSITIV bieten wir authentisches Pilates mit zertifizierten Instruktoren in einer luxuriösen Umgebung.
              </p>
              <ul className="space-y-4">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-black flex-shrink-0 mt-0.5" />
                    <span className="text-black/80">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Pilates Types */}
      <section className="bg-black py-24">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white">
              Unsere Pilates-Angebote
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Wählen Sie das Pilates-Training, das am besten zu Ihren Zielen passt.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pilatesTypes.map((type, index) => (
              <div key={index} className="group bg-white overflow-hidden hover:shadow-2xl transition-shadow">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img 
                    src={type.image}
                    alt={type.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute top-4 right-4 bg-black text-white px-3 py-1 text-sm font-bold">
                    {type.duration}
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-4 text-black">{type.title}</h3>
                  <p className="text-black/70 mb-6 leading-relaxed">{type.description}</p>
                  <Button asChild className="w-full bg-black text-white hover:bg-black/90">
<a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">Jetzt buchen</a>
</Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Studio */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Unsere Pilates-Studios
              </h2>
              <p className="text-lg text-black/80 mb-6 leading-relaxed">
                Jeder POSITIV Club verfügt über ein dediziertes Pilates-Studio, ausgestattet mit professionellen Reformern und allen notwendigen Hilfsmitteln.
              </p>
              <p className="text-lg text-black/80 mb-8 leading-relaxed">
                Unsere Studios bieten eine ruhige, konzentrierte Atmosphäre, in der Sie sich voll auf Ihr Training konzentrieren können. Kleine Gruppengrenßen garantieren individuelle Aufmerksamkeit.
              </p>
              <Button size="lg" className="bg-black text-white hover:bg-black/90 h-12 px-8">
                Studios ansehen
              </Button>
            </div>
            <div className="relative aspect-square">
              <img 
                src="https://images.pexels.com/photos/917732/pexels-photo-917732.jpeg"
                alt="Studio"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-black text-white py-24">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Bereit für Ihre erste Pilates-Stunde?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Buchen Sie Ihre kostenlose Probestunde und erleben Sie die transformative Kraft von Pilates.
          </p>
          <Button asChild size="lg" className="bg-white text-black hover:bg-white/90 h-12 px-8">
<a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">Probestunde vereinbaren</a>
</Button>
        </div>
      </section>
    </div>
  );
};

export default Pilates;
